import axios from 'axios';
const CancelToken = axios.CancelToken;
let cancel;

export const fetchStates = async (countryCode, welletContext) => {
  try {
    cancel && cancel('Cancel previous ');
    const response = await welletContext.apis.tickets
      .get('/geo/getstates', {
        params: {
          countryCode,
        },
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
      })
      .catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          return null;
        } else {
          return null;
        }
      });

    if (response === null) {
      return;
    }
    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return null;
    }
    throw error;
  }
};
